import { defineSlotRecipe } from '@chakra-ui/react';
import { tooltipAnatomy } from '@chakra-ui/react/anatomy';
// Deep-merges over Chakra's default tooltip recipe and only takes its shadow
// away: the house rule is no shadows, and the inverted fill already sets the
// tooltip apart from any surface. The anatomy keeps the slot list in Chakra's
// own order, which the merge relies on.
export const tooltipRecipe = defineSlotRecipe({
    className: 'chakra-tooltip',
    slots: tooltipAnatomy.keys(),
    base: {
        content: {
            boxShadow: 'none',
        },
    },
});
